document.addEventListener('DOMContentLoaded', function() {
  var radios = document.querySelectorAll('.single-option-selector__radio');
  var select = document.getElementById('ProductSelect');

  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    var selectedValues = [];
    var optionGroups = document.querySelectorAll('fieldset.single-option-radio');
    
    optionGroups.forEach(function(group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) selectedValues.push(checked.value);
    });

    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];
      if (option.value) {
        select.value = option.value;
        break;
      }
    }

    var variants = window.__st && window.__st.variants ? window.__st.variants : [];
    for (var j = 0; j < select.options.length; j++) {
      select.selectedIndex = j;
      break;
    }
  }
});
